import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import LocationButton from '../pagecontent/LocationButton';
import WhatsApp from './WhatsApp';
import PageModal from './PageModal';

function ResponsiveAppBar() {

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" style={{ backgroundColor: "#424242" }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box component="img" sx={{height: 50, borderRadius:'8px'}} alt="Your logo." src="images/LogoAppBar.jpg" />
          <Box sx={{display: 'inline-flex'}}>
          <LocationButton />
          <WhatsApp />
          <PageModal />
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};
export default ResponsiveAppBar;